import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "profiler-modal__table" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_paddedContainer = _resolveComponent("paddedContainer")!
  const _component_hadrianModal = _resolveComponent("hadrianModal")!

  return (_openBlock(), _createBlock(_component_hadrianModal, {
    class: "profiler-modal__modal",
    ref: "modal",
    title: "Profiler",
    variant: "wide",
    hideRightButton: "",
    leftButtonText: "close"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_paddedContainer, { class: "profiler-modal" }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("p", null, "The table below contains a list of every call that was made to make this page.", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("ul", { class: "profiler-modal__page-info" }, [
            _createElementVNode("li", null, "To get profiling information for a specific call, click on the link in orange."),
            _createElementVNode("li", null, " Profiler pages will be available for up 30 minutes after the call has finished, unless configured otherwise by the backend. "),
            _createElementVNode("li", null, "Calls are sorted by when they finished, with the most recent calls on top."),
            _createElementVNode("li", null, " The duration displayed is the total roundtrip time of the request, including the time to connect to the server and download the response. As such, it will be longer than the duration displayed on the profiler page, which is in-server time only. "),
            _createElementVNode("li", null, " The list of calls displayed is reset in the router \"afterEach\" hook, after each page change. The information below is only updated when this modal is opened. ")
          ], -1)),
          _createElementVNode("table", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Request Path"),
                _createElementVNode("th", null, "Duration"),
                _createElementVNode("th", null, "Profiler Link")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profilerEntries, (entry) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: entry.profileId
                }, [
                  _createElementVNode("td", null, _toDisplayString(entry.requestPath), 1),
                  _createElementVNode("td", null, _toDisplayString(entry.requestDuration) + " ms", 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: entry.profileUrl,
                      target: "_blank"
                    }, [
                      _createTextVNode(_toDisplayString(entry.profileId.slice(0, 8)) + "  ", 1),
                      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-external-link-alt" }, null, -1))
                    ], 8, _hoisted_2)
                  ])
                ]))
              }), 128))
            ])
          ])
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }, 512))
}